export const colors = {
  stone50: '#fafaf9',
  stone100: '#f5f5f4',
  stone200: '#e7e5e4',
  stone300: '#d6d3d1',
  stone400: '#a8a29e',
  stone500: '#78716c',
  stone600: '#57534e',
  stone700: '#44403c',
  stone800: '#292524',
  stone900: '#1c1917',
  accent50: '#ecfeff',
  accent500: '#06b6d4',
  accent600: '#0891b2',
  accent700: '#0e7490',
  emerald50: '#ecfdf5',
  emerald600: '#059669',
  emerald700: '#047857',
  amber50: '#fffbeb',
  amber600: '#d97706',
  amber700: '#b45309',
  rose50: '#fff1f2',
  rose600: '#e11d48',
  rose700: '#be123c',
  blue50: '#eff6ff',
  blue600: '#2563eb',
  blue700: '#1d4ed8',
  violet50: '#f5f3ff',
  violet600: '#7c3aed',
  violet700: '#6d28d9',
  indigo50: '#eef2ff',
  indigo600: '#4f46e5',
  indigo700: '#4338ca',
};

export const matte = {
  blue: '#74a0d6',
  purple: '#8a7bb8',
  green: '#79b38a',
  red: '#c57878',
  amber: '#c49a4f',
  teal: '#55a39b',
  rose: '#b77a98',
  rust: '#b3784f',
  indigo: '#7a76b5',
  grey: '#9ca3af',
};

export const tableStyles = {
  tableWrap: {
    width: '100%',
    overflow: 'auto',
    maxHeight: '70vh',
    borderRadius: 10,
    border: `1px solid ${colors.stone200}`,
    background: '#fff',
  },
  table: {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: 0,
    fontSize: 12,
  },
  th: {
    textAlign: 'left',
    padding: '6px 10px',
    fontSize: 10,
    fontWeight: 700,
    color: colors.stone500,
    textTransform: 'uppercase',
    letterSpacing: '.06em',
    borderBottom: `2px solid ${colors.stone200}`,
  },
  tr: {
    background: '#fff',
    cursor: 'pointer',
    transition: 'background .12s ease',
  },
  td: {
    padding: '10px 10px',
    fontSize: 13,
    color: colors.stone700,
    verticalAlign: 'top',
    borderBottom: `1px solid ${colors.stone100}`,
  },
  badge: {
    display: 'inline-block',
    padding: 0,
    borderRadius: 0,
    fontSize: 12,
    fontWeight: 500,
    background: 'transparent',
  },
  linkBtn: {
    padding: 0,
    background: 'transparent',
    border: 'none',
    color: colors.stone500,
    fontWeight: 600,
    cursor: 'pointer',
    fontSize: 12,
  },
  btnIcon: {
    width: 28,
    height: 28,
    padding: 0,
    background: 'transparent',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
    color: colors.stone500,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.15s ease',
  },
  btnSecondary: {
    padding: '7px 12px',
    fontSize: 12,
    fontWeight: 500,
    color: colors.stone700,
    background: '#fff',
    border: `1.5px solid ${colors.stone200}`,
    borderRadius: 8,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
  },
  statusWithDot: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 12,
    fontWeight: 600,
    color: colors.stone500,
  },
  statusDot: (color) => ({
    width: 8,
    height: 8,
    borderRadius: 999,
    background: color,
    flexShrink: 0,
  }),
  catDot: (c) => ({
    display: 'inline-block',
    width: 8,
    height: 8,
    borderRadius: '50%',
    background: c,
    marginRight: 6,
  }),
};

export const billingTableCSS = () => `
@keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
@keyframes spin { to { transform: rotate(360deg); } }
.billing-row:hover td { background: ${colors.stone50}; }
.billing-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
}
`;
